import { ReactNode } from 'react';
import cx from 'classnames';

import { CalendarIcon, CameraIcon } from 'components/Icon';

import styles from './FreeTrialPanel.StartStreaming.module.scss';

export type StartStreamingProps = {
  message?: string | ReactNode;
  onStart?(): void;
  onSchedule?(): void;
};

const StartStreaming = ({ message, onSchedule, onStart }: StartStreamingProps) => (
  <div className={styles.container}>
    {message && <h3 className={styles.message}>{message}</h3>}
    <div className={styles.actions}>
      <button type="button" className={cx(styles.action, styles.start)} onClick={onStart}>
        <CameraIcon />
        <span>Start event</span>
      </button>
      <button type="button" className={cx(styles.action, styles.schedule)} onClick={onSchedule}>
        <CalendarIcon />
        <span>Schedule event</span>
      </button>
    </div>
  </div>
);

export default StartStreaming;
